Pegasus.HistoryDirectionView = Em.View.extend({
  tagName: 'li'
});

Pegasus.HistoryOperationsView = Em.View.extend({
  classNames: ['vr-history-operations'],
  templateName: 'history_operations',
  listView: Em.View.extend({
    viewName: 'listContainer',
    classNames: ['vr-list-wrapper'],
    templateName: 'history_operations/list',
    classNameBindings: ['visible'],

    visible: function(_,value) {
      if ( typeof( value ) !== 'undefined' ) {
        if ( value === true ) {

          $(window).one('click.' + this.get('elementId'), function(){
            Em.run( this, 'set', 'visible', false );
          }.bind(this));
        }

        return value;
      }

      return false;
    }.property(),
    listContentView: Em.CollectionView.extend({
      viewName: 'list',
      tagName: 'ul',
      contentBinding: 'controller.content',
      classNames: ['check-points', 'history-menu'],
      itemViewClass: Em.View.extend({
        templateName: 'history_operations/line_item',
        tagName: 'li',
        classNames: ['check-point'],
        classNameBindings: ['mightBeRemoved:disabled'],
        mightBeRemoved: function(){
          var command = this.get('content'),
            myPosition = this.get('controller.content.content').indexOf( command );

          if ( this.get('controller.position') <= myPosition ) {
            return true;
          }

          return false;
        }.property('controller.position'),
        click: function(e){
          this.set('parentView.parentView.visible', false);
          var index = this.get('controller.content').indexOf( this.get('content') );
          if ( this.get('controller.isRolling') ) { debugger;return; }
          this.get('controller.content').rollTo(index + 1);
          return false;
        }
      })
    })
  }),
  directionsView: Em.ContainerView.extend({
    tagName: 'ul',
    classNames: ['vr-history-content-wrapper'],
    childViews: ['backward', 'checkPoints', 'forward'],

    click: function(){
      return false;
    },

    backward: Pegasus.HistoryDirectionView.extend({
      classNames: ['vr-history-backward'],
      classNameBindings: ['isNoop:disabled'],
      isNoop: Em.computed.not('controller.content.canRollback'),
      template: function(){
        return Em.Handlebars.compile('<div class="undo-arrow"><a href="#"></a></div><a href="#" class="undo-text">{{t g.undo}}</a>');
      }.property(),
      click: function(){
        Pegasus.stateMachine.send('didFinishEditing');
        Pegasus.stateMachine.transitionTo('idling');
        var manager = Em.get(Pegasus, 'CommandManager.instance');
        manager.rollback();
        return false;
      }
    }),
    checkPoints: Em.View.extend({
      tagName: 'li',
      templateName: 'history_operations_overview',
      classNames: ['check-point-container'],
      classNameBindings: ['isNoop:disabled'],
      isNoop: Em.computed.lt('controller.content.length', 1),
      listBinding: 'parentView.parentView.listContainer',

      click: function(){
        var manager = Em.get(Pegasus, 'CommandManager.instance');

        Pegasus.stateMachine.send('didFinishEditing');
        if ( manager.get('length') ) {
          this.get('parentView.parentView.listContainer').toggleProperty('visible');
        }
        return false;
      },

      collectionView: Em.View.extend({
        viewName: 'collection',
        classNames: ['vr-history-container']
      })
    }),
    forward: Pegasus.HistoryDirectionView.extend({
      classNames: ['vr-history-forward'],
      classNameBindings: ['isNoop:disabled'],
      isNoop: Em.computed.not( 'controller.content.canRollforward' ),
      template: function(){
        return Em.Handlebars.compile('<div class="redo-arrow"><a href="#"></a></div><a href="#" class="redo-text">{{t g.redo}}</a>');
      }.property(),
      click: function(){
        Pegasus.stateMachine.send('didFinishEditing');
        Pegasus.stateMachine.transitionTo('idling');
        var manager = Em.get(Pegasus, 'CommandManager.instance');
        manager.rollforward();
        return false;
      }
    })
  })
});
